import React from "react";
import BaseDefault from "../../core/BaseDefault";

export default function Animation_Page(){
    return(
        <BaseDefault
            styles="title-page"
            title="Animation"
        >
        
        </BaseDefault>
    )
}